import {
  GoogleDrive,
  SharePoint,
  Confluence,
} from 'src/components/Icons/Dependencies'
import styled from 'styled-components/macro'
import { compose, margin, textStyle } from 'styled-system'
import palette from 'src/designSystem/variables/palette'
import { TypeButton } from '../FileType/TypeSelector.styles'

export const DocumentDetailsContainer = styled.div.attrs({
  mb: 'l',
})`
  ${margin}
  position: relative;
`

export const Label = styled.label.attrs({
  mb: 'xxxs',
  textStyle: 'body.default',
})`
  ${compose(margin, textStyle)}
  display: flex;
  justify-content: space-between;
`

export const GoogleDriveIcon = styled(GoogleDrive)`
  width: 48px;
  height: 48px;
`
export const GoogleDriveSmallIcon = styled(GoogleDrive)`
  width: 24px;
  height
`
export const ConfluenceIcon = styled(Confluence)`
  width: 48px;
  height: 48px;
`
export const ConfluenceSmallIcon = styled(Confluence)`
  width: 24px;
  height: 24px;
`

export const SharePointIcon = styled(SharePoint)`
  width: 48px;
  height: 48px;
`
export const SharePointSmallIcon = styled(SharePoint)`
  width: 24px;
  height: 24px;
`

export const StyledTypeButton = styled(TypeButton)`
  margin: 0;
  cursor: pointer;
`

export const CitationPreviewContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

export const CitationPreviewQuestion = styled.div`
  font-weight: 300;
  font-size: 12px;
  color: ${palette.neutral[600]};
`

export const CitationPreviewAnswer = styled.div`
  font-weight: 400;
  font-size: 12px;
  color: ${palette.neutral[600]};
`
export const DocumentManagementFilesContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 10px;
  border: 1px solid ${palette.neutral[100]};
  border-radius: 8px;
  width: 100%;
  height: 100%;
  min-height: 200px;
  max-height: 300px;
  margin-top: 8px;
  overflow: auto;
`

export const DMTitle = styled.span`
  font-weight: 500;
  font-size: 14px;
  letter-spacing: -0.3px;
  margin-bottom: 0;
  margin-top: 2px;
`

export const DMSize = styled.span`
  font-weight: 400;
  font-size: 12px;
  letter-spacing: 0;
  margin-top: 2px;
`
